<app-referrals-standard-listing
  [loadingReferrals]="loadingReferrals"
  [eligibleReferrals]="eligibleReferrals"
  [ineligibleReferrals]="ineligibleReferrals"
  [referralMatchOptions]="referralMatchOptions"
  [showIneligibleReferrals]="showIneligibleReferrals"
  (referralMatchOptionChange)="onReferralMatchOptionChange($event)" />
